export default {
    markets: {
        title: 'Markets',
        setRefreshTimeSuccessMessage: 'Refresh time updated',
        setRefreshTimeErrorMessage:
            'Something went wrong when update refresh time',
        updateWatchlistSuccessMessage: 'Markets config successfully updated',
        headers: [
            {
                label: 'Symbol',
                labelMobile: 'Sym',
                key: 'symbol',
            },
            {
                label: 'Exchange',
                labelMobile: 'Ex',
                key: 'exchange',
            },
            {
                label: 'Bid Price',
                labelMobile: 'Bid',
                key: 'bid_price',
            },
            {
                label: 'Bid Qty',
                labelMobile: 'Bid Qty',
                key: 'bid_qty',
            },
            {
                label: 'Ask Price',
                labelMobile: 'Ask',
                key: 'ask_price',
            },
            {
                label: 'Ask Qty',
                labelMobile: 'Ask Qty',
                key: 'ask_qty',
            },
            {
                label: 'Last Price',
                labelMobile: 'Last',
                key: 'last_price',
            },
            {
                label: 'Last Qty',
                labelMobile: 'Last Qty',
                key: 'last_qty',
            },
        ],
    },
};
